import React from 'react';
import CmsContentList from 'components/data/CmsContentList.js';
import CmsContentRenderer from 'components/data/CmsContentRenderer.js';
import FundingSourceInfoChip from 'components/card-icons/FundingSourceInfoChip.js';

import * as style from 'components/Modal.module.css';

import Toast, { TYPE_ERROR } from 'components/Toast';
import TokenNameAndPan from 'components/account/card/TokenNameAndPan';
import { nameObjToString } from 'pages/group-admin/members/MembersTable';
import { useGlobalToastsContext } from 'context/ToastProvider';


const cms = {
	removeAddressFailHeader: "miscText.account-org-address-remove-error-header",
	removeAddressFailBody: "miscText.account-org-address-remove-error-linked",

	removeAddressNoDependencyHeader: "miscText.remove-address-failed-header",
	removeAddressNoDependencyDesc: "miscText.remove-address-failed-desc",
};


const CreditCardListItem = ({ wsFundingSourceInfo }) => {
	const creditCard = wsFundingSourceInfo.creditCard ?? {};
	const creditCardType = creditCard.creditCardType;
	const maskedPan = creditCard.maskedPan;
	const pgCardId = creditCard.pgCardId;
	const nickname = wsFundingSourceInfo.nickname;

	if (wsFundingSourceInfo.directDebit) {
		return (
			<FundingSourceInfoChip
				{...{ wsFundingSourceInfo }}
			/>
		);
	}

	return (
		<TokenNameAndPan
			tokenInfo={{
				creditCardType,
				maskedPan,
				pgCardId,
				tokenNickname: nickname,
			}}
		/>
	);
};

const LinkedFundingSourceList = ({ fundingSourceDependencies }) => (
	<div className={style.accountListWrapper}>
		{fundingSourceDependencies.map(wsFundingSourceInfo => (
			<div key={wsFundingSourceInfo.fundingSourceId} className={style.accountListItem}>
				<CreditCardListItem {...{ wsFundingSourceInfo }} />
			</div>
		))}
	</div>
);

const ContactListItem = ({ wsCustomerContactInfoB2b }) => (
	<div>
		{nameObjToString(wsCustomerContactInfoB2b.name)}
	</div>
);

const LinkedContactsList = ({ contactDependencies }) => (
	<div className={style.accountListWrapper}>
		{contactDependencies.map((wsCustomerContactInfoB2b => (
			<div
				className={style.accountListItem}
				key={wsCustomerContactInfoB2b.contactId}
			>
				<ContactListItem {...{ wsCustomerContactInfoB2b }} />
			</div>
		)))}
	</div>
);

export const AddressRemovalFailedDependencies = ({
	fundingSourceDependencies = null,
	contactDependencies = null,
}) => {
	const { removeToast } = useGlobalToastsContext();

	return (
		<CmsContentList list={Object.values(cms)}>{({ cmsContent }) => (
			<Toast
				type={TYPE_ERROR}
				title={cmsContent[ cms.removeAddressFailHeader ]}
				onClosed={removeToast}
				text={<>
					<CmsContentRenderer
						contentKey={cms.removeAddressFailBody}
						fallbackValue="Address can't be removed as it is associated with a payment or contact"
					/>
					{contactDependencies ? <LinkedContactsList {...{ contactDependencies }} /> : null}
					{fundingSourceDependencies ? <LinkedFundingSourceList {...{ fundingSourceDependencies }} /> : null}
				</>}
			/>
		)}</CmsContentList>
	);
};

export const AddressRemovalFailed = () => {
	const { removeToast } = useGlobalToastsContext();

	return (
		<CmsContentList list={Object.values(cms)}>{() =>
			<Toast
				type={TYPE_ERROR}
				title={
					<CmsContentRenderer
						contentKey={cms.removeAddressNoDependencyHeader}
						fallbackValue="Can't remove address"
					/>
				}
				onClosed={removeToast}
				text={
					<CmsContentRenderer
						contentKey={cms.removeAddressNoDependencyDesc}
						fallbackValue="Please set another address to be the default billing address before deleting this one."
					/>
				}
			/>
		}</CmsContentList>
	);
};
